import styled from 'styled-components';

import { ReactComponent as AddListIcon } from 'assets/icons/add-solid.svg';
import { Button, SecondaryButton } from 'components/shared/Button/Button';

export const TriggerButton = styled(SecondaryButton)`
  height: 44px;
  margin-top: 0.5rem;
  white-space: nowrap;
`;

export const TriggerIcon = styled(AddListIcon)`
  height: 1.6rem;
  width: 1.6rem;
  fill: ${(props) => props.theme.special};
  margin-right: 0.8rem;
`;

// Lays out the multi-import modal as a flex column so the table region
// flexes/scrolls and the footer stays visible at the bottom. Scopes the
// .defaultTableWrapper height override to this modal ONLY (the global rule in
// ModalOverlay forces calc(100% - 100px), which pushes the footer off-screen
// and leaves whitespace below the list).
export const MultiImportLayout = styled.div`
  display: flex;
  flex-direction: column;
  /* Fill the modal body minus the sticky close header (.closeModal min 50px) */
  height: calc(100% - 50px);

  .defaultTableWrapper {
    height: auto;
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .container {
      max-height: none;
      flex: 1 1 auto;
      min-height: 0;
      overflow: auto;
    }
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;
  padding: 1rem 0;
  margin-top: 1rem;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  flex: 0 0 auto;
`;

export const SelectedCount = styled.span`
  margin-right: auto;
  font-size: ${(props) => props.theme.small};
  color: ${(props) => props.theme.gray};
`;

export const AddButton = styled(Button)`
  min-width: 14rem;
`;

/* Quantity stepper styled like the detail-line +/- steppers, but smaller */
export const QtyStepperWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const QtyStepperButton = styled.button`
  background-color: #fff;
  padding: 2px;
  color: ${(props) => props.theme.special};
  outline: none;
  border: 1px solid ${(props) => props.theme.special};
  font-weight: bold;
  cursor: pointer;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    width: 16px;
    height: 16px;
  }
`;

export const QtyStepperInput = styled.input<{ $width?: number }>`
  width: ${(props) => (props.$width ? `${props.$width}px` : '75px')};
  text-align: center;
  box-sizing: border-box;
  border: 1px solid #d3d3d3;
  border-radius: 6px;
  margin: 0 5px;
  padding: 4px;
  font-size: ${(props) => props.theme.small};
  outline: none;
  -moz-appearance: textfield;
  appearance: textfield;
  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  :focus {
    box-shadow: 0px 0px 1px 1px ${(props) => props.theme.special};
  }
`;
